if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.ifMediaStack = this.hasAttribute("data-media-stack");
        this.lastVariantMediaId = parseInt(
          this.querySelector(".is-current-variant-media").dataset.mediaId,
        ); // 当前选择的产品变体对应的MediaId

        this.initResponsiveImageGuard();

        if (!this.thumbnails) return;
        this.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((thumbnail) => {
            thumbnail.addEventListener(
              "click",
              this.onThumbnailClick.bind(this),
            );
          });

        this.addEventListener("sliderChanged", this.onSlideChanged.bind(this));
      }

      get viewer() {
        return this.querySelector('[id^="Gallery-Viewer"]');
      }

      get thumbnails() {
        return this.querySelector('[id^="Gallery-Thumbnail-Slider"]');
      }
/**
 * 防止产品图库图片的响应式 srcset 被其它脚本清空。
 * 如果 srcset 丢失，则直接根据当前产品图片 URL 重新生成。
 */
initResponsiveImageGuard() {
  const widths = [
    246,
    493,
    600,
    713,
    823,
    990,
    1100,
    1206,
  ];

  const repairImage = (img) => {
    if (!img?.matches("img.product-preview-image")) return;

    const mediaItem = img.closest(".product-media-item");
    if (!mediaItem) return;

    // clone 不处理
    if (mediaItem.classList.contains("slider-slide--clone")) return;

    // 已经有正常 srcset，不处理
    if ((img.getAttribute("srcset") || "").trim()) return;

    // 如果本身有 data-srcset，优先直接恢复
    const dataSrcset = img.getAttribute("data-srcset");

    if (dataSrcset) {
      img.setAttribute("srcset", dataSrcset);
      img.removeAttribute("data-srcset");
      return;
    }

    const currentSrc =
      img.getAttribute("src") ||
      img.currentSrc;

    if (!currentSrc) return;

    // 跳过透明占位图
    if (currentSrc.includes("transparent.png")) return;

    try {
      const baseUrl = new URL(
        currentSrc,
        window.location.origin,
      );

      baseUrl.searchParams.delete("width");

      const srcset = widths
        .map((width) => {
          const sizedUrl = new URL(baseUrl.href);
          sizedUrl.searchParams.set("width", width);

          return `${sizedUrl.href} ${width}w`;
        })
        .join(", ");

      img.setAttribute("srcset", srcset);
    } catch (error) {
      console.warn("Responsive image repair failed:", error);
    }
  };

  const repairAllImages = () => {
    this.viewer
      .querySelectorAll(
        ".product-media-item:not(.slider-slide--clone) img.product-preview-image"
      )
      .forEach(repairImage);
  };

  requestAnimationFrame(repairAllImages);
  setTimeout(repairAllImages, 500);

  const observer = new MutationObserver((records) => {
    let needsRepair = false;

    records.forEach((record) => {
      if (
        record.type === "attributes" &&
        ["src", "srcset", "data-srcset"].includes(record.attributeName)
      ) {
        repairImage(record.target);
      }

      if (record.type === "childList" && record.addedNodes.length) {
        needsRepair = true;
      }
    });

    if (needsRepair) {
      requestAnimationFrame(repairAllImages);
    }
  });

  observer.observe(this.viewer, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["src", "srcset", "data-srcset"],
  });

  this.addEventListener("sliderChanged", () => {
    requestAnimationFrame(repairAllImages);
  });
}
      /**
       * 媒体切换事件
       * @param event
       */
      onSlideChanged(event) {
        if (!event || !event.detail) return;

        const mediaId = event.detail.currentElement.dataset.mediaId;

        // 滚动缩略图到当前媒体
        const thumbnail = this.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        if (!thumbnail) return;

        if (!thumbnail.querySelector(".thumbnail-media").hasAttribute("aria-current")) {
          this.setActiveThumbnail(thumbnail);
        }
        if (this.thumbnails.initSliderStatus)
          this.thumbnails.moveElementToOptimalPosition(thumbnail); // 将缩略图元素移动到合适的位置
      }

      /**
       * 点击缩略图处理
       */
      onThumbnailClick(event) {
  const thumbnail = event.currentTarget;

  // 根据缩略图恢复该位置原本的产品图片
  this.restoreMediaFromThumbnail(thumbnail);

  this.setActiveThumbnail(thumbnail);
  this.changeMedia(thumbnail.getAttribute("data-target"));
}

/**
 * 从底部缩略图获取真实产品图片，
 * 恢复被颜色选项覆盖的主图。
 */
restoreMediaFromThumbnail(thumbnail) {
  const mediaId = thumbnail.getAttribute("data-target");

  const media = this.viewer.querySelector(
    `.product-media-item[data-media-id="${mediaId}"]`,
  );

  const mainImage = media?.querySelector("img");
  const thumbnailImage = thumbnail.querySelector("img");

  if (!mainImage || !thumbnailImage) return;

  const thumbnailSrcset =
    thumbnailImage.getAttribute("srcset") ||
    thumbnailImage.getAttribute("data-srcset");

  if (!thumbnailSrcset) return;

  const imageUrls = thumbnailSrcset
    .split(",")
    .map((item) => item.trim().split(/\s+/)[0])
    .filter(Boolean);

  const originalImageUrl =
    imageUrls[imageUrls.length - 1] ||
    thumbnailImage.currentSrc;

  if (!originalImageUrl) return;

  // 重新生成适合主图使用的高清响应式图片
  const baseUrl = new URL(
    originalImageUrl,
    window.location.origin,
  );

  baseUrl.searchParams.delete("width");

  const widths = [
    246,
    493,
    600,
    713,
    823,
    990,
    1100,
    1206,
    1600,
  ];

  const mainSrcset = widths
    .map((width) => {
      const sizedUrl = new URL(baseUrl.href);
      sizedUrl.searchParams.set("width", width);

      return `${sizedUrl.href} ${width}w`;
    })
    .join(", ");

  mainImage.setAttribute("src", baseUrl.href);
  mainImage.setAttribute("srcset", mainSrcset);
  mainImage.removeAttribute("data-srcset");
}

      /**
       * 更新相册，如果需要隐藏其它变体图片，需要重新安装轮播组件
       * @param currentVariantMediaId 当前变体的 Featured Media Id
       */
      updateGallery(currentVariantMediaId) {
        if (
          currentVariantMediaId === this.lastVariantMediaId ||
          currentVariantMediaId == null
        )
          return;
        this.lastVariantMediaId = currentVariantMediaId;

        // 修改当前变体关联的媒体
        this.viewer
          .querySelectorAll(".is-current-variant-media")
          .forEach((element) =>
            element.classList.remove("is-current-variant-media"),
          );
        this.viewer
          .querySelectorAll(`[data-media-id="${currentVariantMediaId}"]`)
          .forEach((element) =>
            element.classList.add("is-current-variant-media"),
          );

        if (this.thumbnails) {
          this.thumbnails
            .querySelector(".is-current-variant-thumbnail")
            ?.classList.remove("is-current-variant-thumbnail");
          this.thumbnails
            .querySelector(`[data-target="${currentVariantMediaId}"]`)
            ?.classList.add("is-current-variant-thumbnail");
        }

        // 如果开启了隐藏其它变体设置
        if (this.hasAttribute("data-hide-variants")) {
          // 切换当前变体的媒体组
          const groupName = this.viewer.querySelector(
            `[data-media-id="${currentVariantMediaId}"]`,
          )?.dataset.mediaGroup;
          this.viewer
            .querySelectorAll(".is-current-variant-media-group")
            .forEach((element) =>
              element.classList.remove("is-current-variant-media-group"),
            );
          if (groupName) {
            this.viewer
              .querySelectorAll(`[data-media-group='${groupName}']`)
              .forEach((element) => {
                element.classList.add("is-current-variant-media-group");
              });
          }

          if (this.thumbnails) {
            this.thumbnails
              .querySelectorAll(".is-current-variant-thumbnail-group")
              .forEach((element) =>
                element.classList.remove("is-current-variant-thumbnail-group"),
              );
            if (groupName) {
              this.thumbnails
                .querySelectorAll(`[data-thumbnail-group='${groupName}']`)
                .forEach((element) => {
                  element.classList.add("is-current-variant-thumbnail-group");
                });
            }
          }

          // 如果启用了隐藏其它变体媒体，需要重新初始化轮播
          if (!this.ifMediaStack) {
            this.viewer.reInstall();
            if (this.thumbnails) this.thumbnails.reInstall();
          }
        }

        this.changeMedia(currentVariantMediaId);

        // 手机端，当媒体切换的时候，返回页面顶部
        if (webvista.isMobileScreen()) {
          webvista.scrollElementToHeaderBottom(this, 16);
        }
      }

      /**
       * 设置活跃媒体
       * @param mediaId
       */
      changeMedia(mediaId) {
        const activeMedia = this.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );

        if (this.ifMediaStack) {
          // 如果是 Stack 布局，需要将当前变体 Featured Media 放置最前面
          activeMedia.parentElement.prepend(activeMedia);
        } else {
          // 轮播模式，切换当前轮播
          if (this.viewer.initSliderStatus)
            this.viewer.slideByElement(activeMedia);
        }
      }

      /**
       * 设置活跃缩略图
       * @param thumbnail
       */
      setActiveThumbnail(thumbnail) {
        if (!this.thumbnails || !thumbnail) return;

        this.thumbnails
          .querySelectorAll(".thumbnail-media")
          .forEach((element) => element.removeAttribute("aria-current"));

        thumbnail.querySelector("button").setAttribute("aria-current", true);
      }
    }
  );
}




